import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { MaintenancesApi } from '@api/maintenances/maintenances.api';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { DialogQuotationComponent } from 'app/main/quotations/dialog/dialog-quotation.component';
import { QuotationService } from 'app/main/quotations/services/quotation.service';
import { sumBy } from 'lodash';
import { debounceTime } from 'rxjs/operators';
import english from '../../../../i18n/en.json';
import spanish from '../../../../i18n/es.json';
import portuguese from '../../../../i18n/pt.json';
var TabQuotationsComponent = /** @class */ (function () {
    function TabQuotationsComponent(data, fuseTranslationLoaderService, quotationsService, fuseProgressBarService, authenticationService, matDialogRef, matDialog, maintenancesApi) {
        this.data = data;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.quotationsService = quotationsService;
        this.fuseProgressBarService = fuseProgressBarService;
        this.authenticationService = authenticationService;
        this.matDialogRef = matDialogRef;
        this.matDialog = matDialog;
        this.maintenancesApi = maintenancesApi;
        this.quotations = [];
        this.hasEditQuotationPermission = this.authenticationService.hasPermission('quotations-edit');
        this.hasPaymentsBetaFlag = this.authenticationService.hasFlags('paymentsFeatureFlag');
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.maintenance = data.maintenance;
    }
    TabQuotationsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b, quotation, services, products;
            var e_1, _c;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.getQuotations()];
                    case 1:
                        _d.sent();
                        try {
                            for (_a = tslib_1.__values(this.quotations), _b = _a.next(); !_b.done; _b = _a.next()) {
                                quotation = _b.value;
                                services = quotation.items.filter(function (item) { return item.productService.type === 'service'; });
                                products = quotation.items.filter(function (item) { return item.productService.type === 'product'; });
                                quotation.productsCount = sumBy(products, 'quantity');
                                quotation.servicesCount = sumBy(services, 'quantity');
                                quotation.productsValueTotal = sumBy(products, 'total');
                                quotation.servicesValueTotal = sumBy(services, 'total');
                                quotation.expensesValueTotal = sumBy(quotation.expenses, 'value');
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    TabQuotationsComponent.prototype.openDialog = function (quotationId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var quotation, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.fuseProgressBarService.show();
                        if (!quotationId) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.quotationsService.getById(quotationId)];
                    case 1:
                        quotation = _a.sent();
                        this.fuseProgressBarService.hide();
                        return [4 /*yield*/, this.matDialog.open(DialogQuotationComponent, {
                                panelClass: 'dialog-quotation',
                                data: {
                                    quotation: quotation,
                                    isViewMode: !this.hasEditQuotationPermission
                                }
                            })
                                .afterClosed()
                                .toPromise()];
                    case 2:
                        result = _a.sent();
                        if (result && result.reload) {
                            this.fuseProgressBarService.show();
                            this.getQuotations();
                            this.fuseProgressBarService.hide();
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    TabQuotationsComponent.prototype.getQuotations = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.maintenancesApi
                            .searchMaintenanceQuotations({ maintenanceId: this.maintenance.id })
                            .pipe(debounceTime(500))
                            .toPromise()
                            .then(function (quotations) {
                            quotations.map(function (quotation) {
                                var services = quotation.items.filter(function (item) { return item.productService.type === 'service'; });
                                var products = quotation.items.filter(function (item) { return item.productService.type === 'product'; });
                                quotation.productsCount = sumBy(products, 'quantity');
                                quotation.servicesCount = sumBy(services, 'quantity');
                                quotation.productsValueTotal = sumBy(products, 'total');
                                quotation.servicesValueTotal = sumBy(services, 'total');
                                return quotation;
                            });
                            _this.quotations = quotations;
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return TabQuotationsComponent;
}());
export { TabQuotationsComponent };
